import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { Spinner, Box, Text, Input, Button, Flex, IconSvg } from "samba-ui";
import styled from "styled-components";

import { validateEmail } from "../../../utils";

const CloseButton = styled(Box)`
  width: 16px;
  height: 16px;
  svg {
    cursor: pointer;
  }
  path {
    fill: #797b81;
  }
`;

const StyledInput = styled(Input)`
  width: 100%;
`;

const modalStyles = {
  overlay: {
    display: "flex",
    backgroundColor: "rgba(33,37,48,0.9)",
    zIndex: "1000"
  },
  content: {
    position: "static",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    width: "500px",
    padding: 0,
    backgroundColor: "transparent",
    border: "none"
  }
};

const SendCredentialsViaEmailModal = ({ show, onDismiss, onSubmit }) => {
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);

  const isDisabled = () => !validateEmail(email);

  return (
    <Modal
      isOpen={show}
      onRequestClose={onDismiss}
      style={modalStyles}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={true}
    >
      <Flex
        justifyContent="space-between"
        textAlign="left"
        p={4}
        border="1"
        borderColor="#ebebeb"
        bg="white"
      >
        <Text fontSize={2} fontWeight={400}>
          {"Client's Email"}
        </Text>
        <CloseButton onClick={onDismiss}>
          <IconSvg name="close" />
        </CloseButton>
      </Flex>

      <Box bg="white" p={4}>
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          <Box mr={2} width={1 / 4}>
            <Text fontSize={1}>Email</Text>
          </Box>
          <Box width={3 / 4}>
            <StyledInput
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </Box>
        </Flex>
      </Box>
      <Flex
        justifyContent="flex-end"
        p={3}
        borderTop="1"
        borderColor="#ebebeb"
        bg="white"
      >
        {loader ? (
          <Spinner variant="small" />
        ) : (
          <Button
            onClick={() => {
              setLoader(true);
              onSubmit(email);
              setEmail("");
            }}
            disabled={isDisabled()}
          >
            Send Email
          </Button>
        )}
      </Flex>
    </Modal>
  );
};

SendCredentialsViaEmailModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default SendCredentialsViaEmailModal;
